import { Input, InputAdornment } from '@alefeducation/ui-elements-library-core';
import { ProgressComplete } from '@alefeducation/ui-elements-library-icons';
import React, { InputHTMLAttributes } from 'react';

interface EmailValidationProps extends InputHTMLAttributes<HTMLInputElement> {
  showAdornmentIcon?: boolean;
}

const EmailValidationInput = ({
  showAdornmentIcon,
  ...props
}: EmailValidationProps) => {
  const inputProps = () => {
    if (showAdornmentIcon) {
      return {
        endAdornment: (
          <InputAdornment>
            <ProgressComplete
              color="success.100"
              role="icon"
              aria-label="user-exist"
            />
          </InputAdornment>
        ),
      };
    }
    return {};
  };

  return (
    <Input
      name="contact-email"
      placeholder="Enter an e-mail"
      width="396px"
      data-testid={'email-input'}
      {...props}
      {...inputProps()}
    />
  );
};

export default EmailValidationInput;
